import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import shortid from 'shortid';
import ModalUpdate from './ModalUpdateDisbursmentItem';
import ModalUpdateFR from './ModalUpdateFR';
import { getAllFundRequest, updateFRStatus, fundRequestColumn, getAllFundRequestsDisbursment } from './actions';


class FundRequestList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fundRequestList: [],
            loading: true,
            selectedId: '',
            modalShown: false,
            modalShownFR: false,
            updateDone: false,
        };
        this.updateFRStatus = updateFRStatus.bind(this);
        this.fundRequestColumn = fundRequestColumn.bind(this);
    }
    async componentWillMount(bypass = false) {
        if (!bypass) {
            this.setState({
                loading: true,
            });
        }

        const fundRequestList = await getAllFundRequest(this.props.user.loggedInUser.AccountId, this.props.user.siteToken.hash);
        let disbursment = await getAllFundRequestsDisbursment(this.props.user.loggedInUser.AccountId, this.props.user.siteToken.hash);

        // removing duplicate value
        disbursment = [...new Set(disbursment.records.map(item => item))];
        // merging data of fund request with disbursment.
        for (let i = 0; i < fundRequestList.records.length; i++) {
            for (let j = 0; j < disbursment.length; j++) {
                if (fundRequestList.records[i].Name === disbursment[j].Fund_Request__r.Name) {
                    fundRequestList.records[i].disbursment = disbursment[j];
                }
            }
        }

        if (bypass) {
            return fundRequestList.records || [];
        }

        this.setState({ loading: false, fundRequestList: fundRequestList.records || [] });
    }

    render() {
        const filterMethod = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null && typeof row[id] === 'string') {
                const returnValue = row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true;
                return returnValue;
            }
        };

        return (
            <div className="card">
                <h3>Fund Request</h3>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <p style={{ textAlign: 'center' }}>
                                {this.state.loading ? <i className="fa fa-3x fa-spinner fa-spin" /> : null}
                            </p>
                            <ReactTable
                                data={this.state.fundRequestList}
                                columns={this.fundRequestColumn()}
                                defaultPageSize={10}
                                defaultFilterMethod={filterMethod}
                                filterable
                            />
                        </div>
                    </div>
                </div>
                <ModalUpdate
                    id={this.state.selectedId}
                    visible={this.state.modalShown}
                    hideModal={() => this.setState({ modalShown: false })}
                />
                <ModalUpdateFR
                    id={this.state.selectedId}
                    visible={this.state.modalShownFR}
                    hideModal={() => this.setState({ modalShownFR: false })}
                    afterSaveCallback={() => this.componentWillMount()}
                />
            </div>
        );
    }
}

FundRequestList.propTypes = {
    user: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        getAllFundRequest,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    objectInfoFR: state.objectInfo.Fund_Request__c,
});


export default connect(mapStateToProps, mapDispatchToProps)(FundRequestList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/FundRequest/FundRequestList.js
// module id = 976
// module chunks = 0